import { render } from "./ProductVariants.vue?vue&type=template&id=0f266f09&scoped=true"
import script from "./ProductVariants.vue?vue&type=script&lang=js"
export * from "./ProductVariants.vue?vue&type=script&lang=js"

import "./ProductVariants.vue?vue&type=style&index=0&id=0f266f09&land=css&lang=css"
import "./ProductVariants.vue?vue&type=style&index=1&id=0f266f09&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f266f09"]])

export default __exports__